// extracted by mini-css-extract-plugin
export default {"pcpCardExpandText":"PCPCard-module__pcpCardExpandText--JF3Og"};